export default __webpack_public_path__ + "assets/audio/1-4448405_clip.mp3";